import React, { memo } from 'react'
interface ChildProps {
  src: string
  size?: string
}
const ResizeImage = memo<ChildProps>(props => {
  const { src, size } = props
  function resizeSrc() {
    if (size?.includes('x')) {
      let resize = size.split('x')
      return `${src}?x-oss-process=image/resize,m_fill,h_${resize[1]},w_${resize[0]}`
    } else {
      return src
    }
  }
  return <img src={resizeSrc()} alt="" />
})

export default ResizeImage
